/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */
import '@webex/internal-plugin-conversation';
import '@webex/internal-plugin-encryption';

import {registerInternalPlugin} from '@webex/webex-core';
import {has} from 'lodash';

import Search from './search';
import config from './config';

registerInternalPlugin('search', Search, {
  config,
  payloadTransformer: {
    predicates: [
      {
        name: 'encryptSearchQuery',
        direction: 'outbound',
        test(ctx, options) {
          if (!has(options, 'body.query')) {
            return Promise.resolve(false);
          }

          if (!has(options, 'body.searchEncryptionKeyUrl')) {
            return Promise.resolve(false);
          }

          if (options.service === 'argonaut') {
            return Promise.resolve(true);
          }

          if (options.url) {
            const service = ctx.webex.internal.services.getServiceFromUrl(options.url);

            return Promise.resolve(service && service.name === 'argonaut');
          }

          return Promise.resolve(false);
        },
        extract(options) {
          return Promise.resolve(options.body);
        },
      },
      {
        name: 'transformObjectArray',
        direction: 'inbound',
        test(ctx, response) {
          return Promise.resolve(has(response, 'body.activities.items[0].objectType')).then(
            (res) => {
              if (!res) {
                return Promise.resolve(false);
              }

              if (response.options.service === 'argonaut') {
                return Promise.resolve(true);
              }

              if (response.options.url) {
                const service = ctx.webex.internal.services.getServiceFromUrl(response.options.url);

                return Promise.resolve(service && service.name === 'argonaut');
              }

              return Promise.resolve(false);
            }
          );
        },
        extract(response) {
          return Promise.resolve(response.body.activities.items);
        },
      },
    ],
    transforms: [
      {
        name: 'encryptSearchQuery',
        direction: 'outbound',
        fn(ctx, object) {
          return ctx.webex.internal.encryption
            .encryptText(object.searchEncryptionKeyUrl, object.query)
            .then((q) => {
              object.query = q;
            });
        },
      },
    ],
  },
});

export {default} from './search';
